let refreshHandler: (() => Promise<boolean>) | null = null;
let refreshInFlight: Promise<boolean> | null = null;

export function registerTokenRefreshHandler(handler: () => Promise<boolean>) {
	refreshHandler = handler;
}

export function unregisterTokenRefreshHandler() {
	refreshHandler = null;
	refreshInFlight = null;
}

export async function refreshAccessToken(): Promise<boolean> {
	if (!refreshHandler) {
		return false;
	}
	if (!refreshInFlight) {
		refreshInFlight = refreshHandler().finally(() => {
			refreshInFlight = null;
		});
	}
	return refreshInFlight;
}
